import { Flex } from "@radix-ui/themes";
import { t } from "i18next";
import React, { Dispatch, SetStateAction } from "react";
import { Button } from "../../../ui/Button";
import { Popover, PopoverTrigger, PopoverContent } from "../../../ui/Popover";
import { GroupingState } from "@tanstack/react-table";
import TableGroupingCategory from "../../../components/Filters/TableGroupingCategory";
import { Tab, useTabsStore } from "../../../stores/TabsStore";
import { TbX } from "react-icons/tb";
import { Separator } from "../../../ui/Separator";

type Props = {
  groupingState: [GroupingState, Dispatch<SetStateAction<GroupingState>>];
  groupingColumns: {categoryName: string, columnId: string}[]
  tab: Tab
};

const Grouping = ({ groupingState, groupingColumns, tab }: Props) => {
  const [grouping, setGrouping] = groupingState; // Общий фильтр
  const addFilters = useTabsStore(store => store.addFilters)

  const changeGrouping = (newState: GroupingState) => {
    addFilters(tab.id, { ...tab.options?.filters, grouping: newState });
    setGrouping(newState);
  }

  const state: [GroupingState, Function] = [grouping, changeGrouping];

  const cleanGrouping = (e: React.MouseEvent<SVGElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setGrouping([]);
    addFilters(tab.id, { ...tab.options?.filters, grouping: [] });
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex flex-none items-center">
          <Button variant="outline" size="datepicker" className="px-0 items-center">
            <span className="px-2">{t("grouping")}</span>
            {/* {grouping.length > 0 ? <span className="border-l w-6 bg-muted h-full p-0.5 flex items-center justify-center hover:bg-destructive hover:text-white rounded-r-md"><TbX className="cursor-pointer" onClick={(e) => cleanGrouping(e)} /></span> : <></>} */}
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent className="px-0 py-0 text-base" align={"start"}>
        <div className="flex items-center justify-between px-3 h-10">
          <div className="leading-6 font-semibold">{t("grouping")}</div>
          <Button variant="outline" size="xs" type="button" onClick={(e) => cleanGrouping(e)}>
            {t("clear")}
          </Button>
        </div>
        <Separator/>
        <div className="space-y-1 py-3 px-3">
          {groupingColumns.map((category) => (
            <TableGroupingCategory
              key={category.columnId}
              categoryName={category.categoryName}
              columnId={category.columnId}
              groupingState={state}
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Grouping;
